import React, {useEffect, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";
import {InputSwitch} from "primereact/inputswitch";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {ConfirmPopup} from "primereact/confirmpopup";
import {InputTextarea} from "primereact/inputtextarea";
import {PickList} from "primereact/picklist";
import {Tooltip} from "primereact/tooltip";
import * as management from "../../../actions/management";
import * as auth from "../../../actions/auth";
import connect from "react-redux/lib/connect/connect";


const RoleGroups = props => {
    const [roleGroups, setRoleGroups] = useState([]);
    const [roleFunctionGroup, setRoleFunctionGroup] = useState([]);
    const [rgcTarget, setRgcTarget] = useState([]);
    const [rgcSource, setRgcSource] = useState([]);

    const [textDetailText, setTextDetailText] = useState('');
    const [textDetailHeader, setTextDetailHeader] = useState('');

    const roleGroupApiPath = "/api/role_group/";
    const rgUpdatePropsType = "UPDATE_RG";
    const rgAddPropsType = "INSERT_RG";
    const rgDeletePropsType = "DELETE_RG";
    const roleAddRole = !!localStorage.getItem('role_add');
    const roleDeleteRole = !!localStorage.getItem('role_delete');
    const roleUpdateRole = !!localStorage.getItem('role_update');

    const [rolGroupName, setRolGroupName] = useState('');
    const [rolGroupDetail, setRolGroupDetail] = useState('');
    const [rgModuleId, setRgModuleId] = useState(null);
    const [rolGroupId, setRolGroupId] = useState(null);
    const [temporaryRgModuleId, setTemporaryRgModuleId] = useState(null);
    const [rolGroupDeleteData, setRolGroupDeleteData] = useState(null);


    const [rgUpdateBtnVisible, setRgUpdateBtnVisible] = useState(false);
    const [rgAddBtnVisible, setRgAddBtnVisible] = useState(false);
    const [rgUpdateDialogVisible, setRgUpdateDialogVisible] = useState(false);
    const [textDetailPopupVisible, setTextDetailPopupVisible] = useState(false);
    const [rgDeletePopupVisible, setRgDeletePopupVisible] = useState(false);
    const [selectedRgDeletingPopupVisible, setSelectedRgDeletingPopupVisible] = useState(false);

    useEffect(() => {
        getRoleGroups();

    }, []);

    useEffect(() => {
        if (rgUpdateBtnVisible && roleFunctionGroup.length > 0) {
            getTargetRoleGroups();
        }
    }, [rgUpdateBtnVisible, roleFunctionGroup]);

    useEffect(() => {
        const props_type = props.management.type;
        const props_management = props.management;
        if (props_type === rgUpdatePropsType && rgUpdateDialogVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                getRoleGroups();
                onHideModal();
            } else {
                props.showError(props_management.management.message);
            }
        } else if (props_type === rgAddPropsType && rgUpdateDialogVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                getRoleGroups();
                onHideModal();
            } else {
                props.showError(props_management.management.message);
            }
        } else if (props_type === rgDeletePropsType && rgDeletePopupVisible) {
            if (props_management.management.result) {
                props.showSuccess(props_management.management.message);
                // setRolGroupDeleteData(null);
                setRgDeletePopupVisible(false);
                getRoleGroups();
            } else {
                props.showError(props_management.management.message);
            }
        }

    }, [props.management]);

    const onHideModal = () => {
        setRgcSource([]);
        setRgcTarget([]);
        setRoleFunctionGroup([]);
        setRolGroupName('');
        setRolGroupDetail('');
        setRgUpdateBtnVisible(false);
        setRgAddBtnVisible(false);
        setRgUpdateDialogVisible(false);
    }

    const getTargetRoleGroups = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/role_group/' + rolGroupId + '/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                        if (res.status === 200) {
                            let data = res.data;

                            if (data.result === 0) {
                                this.showError(data.message)
                            } else {
                                setRgcTarget([]);
                                setRgcSource([]);
                                let rlg_list = roleFunctionGroup;
                                let rgc_list = data;
                                for (let i = 0; i < rlg_list.length; i++) {
                                    if (!rlg_list[i].rfg_flag_delete) {
                                        let contains = false;
                                        for (let j = 0; j < rgc_list.length; j++) {
                                            if (rlg_list[i].rfg_id === rgc_list[j].rfg_id) {
                                                contains = true;
                                                setRgcTarget(rgcTarget => [...rgcTarget, rlg_list[i]]);
                                                break;
                                            }
                                        }
                                        if (!contains) {
                                            setRgcSource(rgcSource => [...rgcSource, rlg_list[i]]);
                                        }
                                    }
                                }
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    }
                )
        }
    }

    const getRoleGroups = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch('/api/role/role_group/list/', {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        if (data.result === 0) {
                            //showError(data.message)
                        } else {
                            setRoleGroups(data)
                        }

                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const rgDelete = () => {
        props.deleteMethod(rolGroupDeleteData, roleGroupApiPath, rgDeletePropsType)
    }

    const rgActionTemplate = (rowData) => {
        return <div>
            <InputSwitch
                checked={rowData['rolg_flag_delete']}
                onChange={() => rgDeleteInitialize(rowData)}
                style={{
                    marginRight: '.5em',
                    visibility: roleDeleteRole ? 'visible' : 'hidden',
                    height: roleDeleteRole ? '' : '0em'
                }}
            />
            <Button
                type="submit"
                title="Düzenle"
                icon="pi pi-pencil"
                className="p-button-warning"
                style={{
                    maxHeight: '1.5em',
                    maxWidth: '1.7em',
                    visibility: roleUpdateRole ? 'visible' : 'hidden',
                    height: roleUpdateRole ? '' : '0em'
                }}
                onClick={() => rgUpdateInitialize(rowData)}>
            </Button>
        </div>
    }

    const rgUpdateInitialize = (rowData) => {
        getRoleGroup(rowData.md_id);
        setRolGroupName(rowData.rolg_name);
        setRolGroupDetail(rowData.rolg_detail);
        setRolGroupId(rowData.rolg_id);
        setRgModuleId(rowData.md_id);
        setRgUpdateBtnVisible(true);
        setRgUpdateDialogVisible(true);
        setRgAddBtnVisible(false);

        // this.getRequest(roleGroupApiPath + rowData.rolg_id + "/", "rg_connection");
    }

    const rgUpdate = () => {
        let rgc_list = [];
        let rgc_target_list = rgcTarget;
        for (let i = 0; i < rgc_target_list.length; i++) {
            rgc_list.push({'rfg_id': rgc_target_list[i].rfg_id})
        }
        let data = {
            rg_name: rolGroupName,
            rg_detail: rolGroupDetail,
            md_id: rgModuleId,
            rg_id: rolGroupId,
            rg_connection: rgc_list,
        };
        //this.setState({rfg_update_dialog_visible:false});
        props.putMethod(data, roleGroupApiPath, rgUpdatePropsType);
    }

    const getRoleGroup = (module_id) => {
        const path = 'api/role/role_function_group/list/' + module_id + '/';
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(path, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        setRoleFunctionGroup(data);
                        setRgcSource(data);
                        // this.setState({role_function_group: data});
                        // this.setState({rgc_source: data});

                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    const rgAddInitialize = () => {
        setRgcSource([]);
        setRgcTarget([]);
        setRolGroupName('');
        setRolGroupDetail('');
        setRolGroupId(null);
        setRgModuleId(null);
        setRgUpdateBtnVisible(false);
        setRgUpdateDialogVisible(true);
        setRgAddBtnVisible(true);
        //this.setState({rgc_source: this.state.role_function_group.filter(rlg => rlg.rfg_flag_delete !== true)});
    }

    const rgAdd = () => {
        let rgc_list = [];
        let rgc_target_list = rgcTarget;
        for (let i = 0; i < rgc_target_list.length; i++) {
            rgc_list.push({'rfg_id': rgc_target_list[i].rfg_id});
        }
        let data = {
            rg_name: rolGroupName,
            rg_detail: rolGroupDetail,
            md_id: rgModuleId,
            rg_flag_delete: false,
            rg_connection: rgc_list
        };
        props.postMethod(data, roleGroupApiPath, rgAddPropsType);
    }

    const rgDeleteInitialize = (rowData) => {
        let data = {
            rolg_id: rowData.rolg_id,
            rolg_flag_delete: !rowData.rolg_flag_delete,
        };
        setRolGroupDeleteData(data);
        setRgDeletePopupVisible(true);

    }

    const rgDetail = (rowData) => {
        return <div>
            {textSummary(rowData['rolg_detail'], rowData['rolg_name'])}

        </div>
    }

    const mdNameTemplate = (rowData) => {
        if (!rowData.md) {
            return <div><span style={{fontSize: '10px'}} className="p-badge p-badge-secondary">Modülsüz</span></div>;
        }
        const md_color = rowData.md.md_color;
        return (
            <div>
                    <span style={{fontSize: '10px', background: md_color}}
                          className="p-badge">{rowData.md.md_name}</span>
            </div>
        )
    }

    const textSummary = (str, header) => {
        if (str.length > 100) {
            return <div>
                {str.substring(0, 100)}...
                <Link onClick={() => textDetail(str, header)} to="#"> Devamını Gör </Link>
            </div>
        } else {
            return str
        }
    }

    const textDetail = (fulltext, text_header) => {
        setTextDetailPopupVisible(true);
        setTextDetailText(fulltext);
        setTextDetailHeader(text_header);
    }

    const rgModuleIdChange = (e) => {
        const module_id = e.target.value;
        setTemporaryRgModuleId(module_id)
        if (rgcTarget.length > 0) {
            setSelectedRgDeletingPopupVisible(true);


        } else {
            setSelectedRgDeletingPopupVisible(false);
            setRgModuleId(module_id);
            getRoleGroup(module_id);
        }
    }

    const rgTemplate = (item) => {
        const md_color = item.md.md_color;
        return (
            <div className="p-grid" style={{border: `1px solid #a2cdf1`, borderRadius: '8px'}}>
                <div className="p-col-1">
                    <Tooltip target=".custom-target-icon"/>
                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                       data-pr-tooltip={item.rfg_detail} data-pr-position="right" data-pr-at="right+5 top"
                       data-pr-my="left center-2" style={{fontSize: '1.2rem', cursor: 'pointer', color: md_color}}>
                    </i>
                </div>
                <div className="p-col-11">
                    <strong
                        style={{
                            fontSize: '10px',
                            marginLeft: '0.2em',
                            marginRight: '0.2em'
                        }}>{item.rfg_name}</strong>
                    <span style={{fontSize: '8px', background: md_color}}
                          className="p-badge">{item.md.md_name}</span>
                </div>
            </div>
        )
    }

    const rgcPickListChange = (event) => {
        setRgcSource(event.source);
        setRgcTarget(event.target);
    }

    const rgAccept = () => {
        setRgcSource([]);
        setRgcTarget([]);
        getRoleGroup(temporaryRgModuleId);
    }

    const rgReject = () => {
        setSelectedRgDeletingPopupVisible(false);
        setTemporaryRgModuleId(null);
    }

    let rg_header = (
        <div style={{'textAlign': 'center'}}>
            Rol Grupları &nbsp;
            <Button icon="pi pi-plus-circle"
                    title="Rol Grupları"
                    style={{visibility: roleAddRole ? 'visible' : 'hidden'}}
                    onClick={rgAddInitialize}
            />
        </div>
    );
    const rg_delete_popup_footer = (
        <div>
            <Button
                label="Evet"
                icon="pi pi-check"
                onClick={rgDelete}/>
            <Button
                label="Hayır"
                icon="pi pi-times"
                onClick={() => setRgDeletePopupVisible(false)}
                className="p-button-secondary"/>
        </div>
    );
    const rg_update_dialog_footer = (
        <div>
            {
                rgUpdateBtnVisible ?
                    <Button
                        label="Güncelle"
                        icon="pi pi-check"
                        onClick={rgUpdate}/>
                    : null}
            {
                rgAddBtnVisible ?
                    <
                        Button
                        label="Ekle"
                        className="p-button-info"
                        icon="pi pi-check"
                        onClick={rgAdd}
                    />
                    : null}
            <Button
                label="Vazgeç"
                icon="pi pi-times"
                onClick={() => rgUpdateDialogVisible(false)}
                className="p-button-secondary"/>
        </div>
    );
    const moduleOptionItems = props.modules.map((data) => (
            {"label": data.md_name, "value": data.md_id}
        )
    );

    return (
        <div>
            <DataTable
                value={roleGroups}
                header={rg_header}
                selectionMode="single"
                emptyMessage="Kayıt bulunamadı"
                paginator={true}
                rows={12}
                resizableColumns={true}
                responsive={true}>
                <Column
                    header="İşlevler"
                    body={rgActionTemplate}
                    style={{
                        width: roleDeleteRole || roleUpdateRole ? '10em' : '0em',
                        visibility: roleUpdateRole || roleDeleteRole ? 'visible' : 'hidden'
                    }}
                />
                <Column
                    field="rolg_id"
                    style={{textAlign: 'center'}}
                    header="No"
                    sortable={true}
                    filter={true}
                />
                <Column
                    field="rolg_name"
                    filterMatchMode="contains"
                    header="Rol Adı"
                    style={{textAlign: 'center'}}
                    sortable={true}
                    filter={true}
                />
                <Column
                    field="md.md_name"
                    style={{textAlign: 'center'}}
                    filterMatchMode="contains"
                    header="Modül"
                    sortable={true}
                    filter={true}
                    body={mdNameTemplate}
                />
                <Column
                    field="rolg_detail"
                    body={rgDetail}
                    header="Açıklama"
                    filterMatchMode="contains"
                    style={{textAlign: 'center'}}
                    filter={true}/>
            </DataTable>

            <div className="content-section implementation">
                <Dialog header="Rol Grubu"
                        visible={rgUpdateDialogVisible}
                        style={{width: '50vw'}}
                        footer={rg_update_dialog_footer}
                        onHide={() => setRgUpdateDialogVisible(false)}
                        dismissableMask={true}
                        maximizable>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Rol Adı</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <InputText id="rol_group_name"
                                       value={rolGroupName}
                                       onChange={event => setRolGroupName(event.target.value)}
                                       size={58}
                            />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Modül</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <Dropdown options={moduleOptionItems}
                                      inputId="rg_module_id"
                                      name="rg_module_id"
                                      value={rgModuleId}
                                      onChange={rgModuleIdChange}
                                      filter={true}
                                      showClear={true}
                                      required={true}
                                      placeholder="Lütfen Modül Seçiniz"/>
                            <ConfirmPopup
                                target={document.getElementById('rg_module_id')}
                                visible={selectedRgDeletingPopupVisible}
                                onHide={() => setSelectedRgDeletingPopupVisible(false)}
                                message="Seçilen Rol Grupları Silinecektir"
                                icon="pi pi-exclamation-triangle"
                                acceptLabel="Devam"
                                rejectLabel="Vazgeç"
                                accept={rgAccept}
                                reject={rgReject}/>
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="input">Açıklama</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <InputTextarea
                                id="rol_group_detail"
                                value={rolGroupDetail}
                                onChange={event => setRolGroupDetail(event.target.value)}
                                name="rol_group_detail"
                                rows={4}
                                cols={58}>
                            </InputTextarea>
                        </div>

                        <div className="p-col-12 p-md-10">
                            <PickList source={rgcSource}
                                      target={rgcTarget}
                                      itemTemplate={rgTemplate}
                                      sourceHeader="Mevcut"
                                      targetHeader="Seçilenler"
                                      responsive={true}
                                      sourceStyle={{height: '300px'}}
                                      targetStyle={{height: '300px'}}
                                      onChange={rgcPickListChange}>
                            </PickList>
                        </div>
                    </div>
                </Dialog>
            </div>

            <div className="content-section implementation">
                <Dialog
                    header="Uyarı!"
                    visible={rgDeletePopupVisible} style={{width: '45vw'}}
                    onHide={() => setRgDeletePopupVisible(false)}
                    footer={rg_delete_popup_footer}>
                    {rolGroupDeleteData ? rolGroupDeleteData.rolg_flag_delete ? 'Pasif Etmek İstediğinizden Emin Misiniz?' :
                        'Aktif Etmek İstediğinizden Emin Misiniz?' : ''}
                </Dialog>
            </div>
            <div className="content-section implementation">
                <Dialog header={textDetailHeader}
                        visible={textDetailPopupVisible}
                        style={{width: '50vw'}}
                        modal={true}
                        onHide={(e) => setTextDetailPopupVisible(false)}>
                    <p>{textDetailText}</p>
                </Dialog>
            </div>

        </div>
    )

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(RoleGroups);


// WEBPACK FOOTER //
// ./src/pages/rolemanagement/components/RoleGroups.jsx